/* @jsx h */
import { ProductsSubPageV2 } from "./ProductsViewV2";

export const ProductsSubPage = ProductsSubPageV2;
